import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../services/authentication.service";
import {delay, mergeMap, retryWhen} from "rxjs/operators";
import {of, throwError} from "rxjs";

@Component({
  selector: 'app-login-success',
  templateUrl: './login-success.component.html',
  styleUrls: ['./login-success.component.scss'],
  standalone: true,
})
export class LoginSuccessComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    const code = this.route.snapshot.queryParams['code'];
    let retries = 3;
    this.authenticationService
      .getSSOToken(code)
      .pipe(retryWhen( errors => errors.pipe(
        delay(1000),
        mergeMap(error => retries-- > 0 ? of(error) : throwError(error))
      ))).subscribe({
      next: (accessInfo) => {
        this.authenticationService.bearerToken = accessInfo.access_token;
        this.authenticationService.isSSO = true;
        this.authenticationService.getSelfInfo().subscribe(selfInfo => {
          this.authenticationService.verifyExists(selfInfo.username).subscribe(value => {
            localStorage.setItem('username', selfInfo.username);
            this.router.navigate(['/orders-dashboard']);
          })
        })

      }
    });
  }

}
